<template>
  <div>
    <v-layout v-show="showMeets" wrap row>
      <v-flex xs12><h1 class="text-xs-center">{{getDate(date).toDateString()}}</h1></v-flex>
      <v-flex xs12 md4 v-for="result in results" :key="result.key">
        <v-card>
          <v-card-title>
            <v-btn block @click="$router.push({'path': '/events', 'query': result.params})">{{result.meet}}</v-btn>
          </v-card-title>
          <v-card-text v-for="score in result.score" :key="score.abbr">
            <v-layout wrap row>
              <v-flex xs12 md6>
                <span>{{score.abbr}}</span>
              </v-flex>
              <v-flex xs12 md6>
                <span>{{score.score}}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {bus} from '../main';
  export default {
    methods: {
      loadPage() {
        if(this.$route.params.date) {
          this.date = this.$route.params.date;
        }
        this.$http.get(`${process.env.VUE_APP_API_URL}/listmeets?date=${this.date}`)
        .then(function(data) {
          this.results = data.body;
          this.results.forEach(r => {
            r.queryString = `date=${this.date}&team=${r.params.team.join("&team=")}`;
          });
        });
      },
      toggleDisplay(val) {
        this.display[val] = true;
        this.showMeets = false;
      },
      getDate(val) {
        return new Date(val.substring(0,4), val.substring(4,6)-1, val.substring(6,8));
      },
      eventLink(meet,eventno) {
        return `/eventno?date=${meet.params.date}&eventno=${eventno}&team=${meet.params.team.join("&team=")}`;
      },
      relayLink(meet,eventno) {
        return `/relayno?date=${meet.params.date}&eventno=${eventno}&team=${meet.params.team.join("&team=")}`;
      },
      refresh() {
        this.loadPage();
      }
    },
    data: () => ({
      date: "",
      showMeets: true,
      display: {},
      results: []
    }),
    watch: {
      '$route.params.date': function() {
        this.loadPage();
      }
    },

    created() {
      bus.$on("refresh", this.refresh);
      this.loadPage();
    },
    destroyed() {
      bus.$off("refresh",this.refresh);
    },
  }
</script>

<style>

</style>
